import { toast } from "sonner";
import { Plus, PencilSimple, Trash } from "@phosphor-icons/react";
import api from "@/lib/api";

// Pick between my named lists and lists shared with me; create / rename / delete my own.
export const ListSwitcher = ({ lists, value, onChange, onChanged, role }) => {
  const owned = lists.owned || [];
  const shared = lists.shared || [];
  const current = owned.find((l) => l.list_id === value) || owned.find((l) => l.is_default);

  const create = async () => {
    const name = window.prompt("Name your new list (e.g. Weekly shop, Party)");
    if (!name?.trim()) return;
    try {
      const { data } = await api.post("/shopping-lists", { name });
      await onChanged();
      onChange(data.list_id);
      toast.success(`Created “${data.name}”`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Couldn't create the list"); }
  };
  const rename = async () => {
    const name = window.prompt("Rename this list", current?.name || "");
    if (!name?.trim() || !current) return;
    try { await api.patch(`/shopping-lists/${current.list_id}`, { name }); await onChanged(); onChange(current.list_id); }
    catch (e) { toast.error(e?.response?.data?.detail || "Couldn't rename"); }
  };
  const remove = async () => {
    if (!current || current.is_default || !window.confirm(`Delete “${current.name}” and everything on it? People you shared it with lose access.`)) return;
    try { await api.delete(`/shopping-lists/${current.list_id}`); toast.success("List deleted"); onChange(""); onChanged(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Couldn't delete"); }
  };

  return (
    <span className="inline-flex items-center gap-1.5 flex-wrap">
      <select value={value} onChange={(e) => onChange(e.target.value)} aria-label="Choose which shopping list to view"
              data-testid="shop-list-switcher" className="input-rf !py-1.5 !w-auto text-sm font-bold">
        {owned.map((l) => <option key={l.list_id} value={l.is_default ? "" : l.list_id}>{l.name}</option>)}
        {shared.length > 0 && (
          <optgroup label="Shared with me">
            {shared.map((j) => <option key={j.share_id} value={j.resource_id}>{j.owner_name}&apos;s {j.name}{j.role === "view" ? " (view)" : ""}</option>)}
          </optgroup>
        )}
      </select>
      <button type="button" onClick={create} data-testid="shop-list-new" title="New list" className="p-2 rounded-full hover:bg-rf-cream-alt"><Plus size={16} weight="bold" /></button>
      {role === "owner" && current && (
        <>
          <button type="button" onClick={rename} data-testid="shop-list-rename" title="Rename list" className="p-2 rounded-full hover:bg-rf-cream-alt"><PencilSimple size={16} /></button>
          {!current.is_default && <button type="button" onClick={remove} data-testid="shop-list-delete" title="Delete list" className="p-2 rounded-full hover:bg-red-50 text-red-700"><Trash size={16} /></button>}
        </>
      )}
    </span>
  );
};
